module.exports = __webpack_public_path__ + "img/market-research.972cb02c.svg";